/* eslint-disable */
import React from 'react';
import { Col } from '@cleartrip/bento';
import classNames from 'classnames'


function TableColumn({children, className, ...otherProps}) {
	const colClassName = classNames('flex flex-middle ', className )
	return (
		<Col {...otherProps} className={colClassName} >
			{children}
		</Col>				

	);
}



export default TableColumn;
